import { v4 as uuidv4 } from 'uuid';
import { FileStatus, UploadingFile } from '@diligentcorp/heracles-form-input';
import { useGetAttachmentUploadUrl } from './use-get-attachment-upload-url';
import { useUploadAttachment } from './use-upload-attachment';

export type UploadAttachment = {
  hbDriveId: string;
  name: string;
  size: number;
  tempId: string;
  status: FileStatus;
};

export const useUploadAttachments = () => {
  const getAttachmentUploadUrl = useGetAttachmentUploadUrl();
  const uploadAttachment = useUploadAttachment();

  const uploadAttachments = async (
    attachments: UploadingFile[],
  ): Promise<UploadAttachment[]> =>
    Promise.all(
      attachments.map((attachment) =>
        (async () => {
          const hbDriveId = uuidv4();

          try {
            const { url } = await getAttachmentUploadUrl.mutateAsync({
              id: hbDriveId,
              name: attachment.file.name,
            });

            await uploadAttachment.mutateAsync({
              url,
              attachment: attachment.file,
            });

            return {
              hbDriveId,
              name: attachment.file.name,
              size: attachment.file.size,
              tempId: attachment.tempId,
              status: FileStatus.Success,
            };
          } catch (error) {
            return {
              hbDriveId,
              name: attachment.file.name,
              size: attachment.file.size,
              tempId: attachment.tempId,
              status: FileStatus.Error,
            };
          }
        })(),
      ),
    );

  return {
    uploadAttachments,
    isLoading: getAttachmentUploadUrl.isPending || uploadAttachment.isPending,
  };
};
